// FLOW Logo Component - Shared across all pages

// Logo URL from uploaded file (JPEG version)
const LOGO_URL = "/images/brand/logo-flow.jpeg";

const FlowLogo = ({ className = "" }) => (
  <img 
    src={LOGO_URL}
    alt="FLOW - Climatisation Premium Paris"
    className={className}
    style={{ objectFit: 'contain' }}
  />
);

export default FlowLogo;
